import type { AlertLocation, AlertPreferences } from './types';

export type NativePushRegistration = {
  installationId: string;
  secret: string;
  revision: number;
  token: string;
  platform: 'android' | 'ios';
  preferences: AlertPreferences;
  location?: AlertLocation;
};

// Never store coordinates, device names or arbitrary notification destinations.
export type NativePushRecord = Omit<NativePushRegistration, 'secret'> & {
  secretHash: string;
  updatedAt: string;
};

export function validInstallationId(value: unknown): value is string {
  return typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
}

export function validRegistrationSecret(value: unknown): value is string {
  return typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
}

export function validFcmToken(value: unknown): value is string {
  return typeof value === 'string' && /^[A-Za-z0-9_:\-]{20,4096}$/.test(value);
}

export function minimalAlertLocation(location: AlertLocation | undefined): AlertLocation | undefined {
  if (!location) return undefined;
  if (!['inside', 'outside', 'unavailable'].includes(location.status) ||
      typeof location.inArea !== 'boolean' || !Number.isFinite(Date.parse(location.checkedAt)) ||
      Date.parse(location.checkedAt) > Date.now() + 60_000) return undefined;
  return {
    status: location.status, inArea: location.inArea,
    area: 'Stone Harbor', radiusMiles: 10, checkedAt: location.checkedAt,
  };
}
